import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ApexChart from 'react-apexcharts';
import { Box } from '@mui/material';

import {
  colors,
  fontWeight,
  Heading,
  Icons,
  Select,
  selectType,
  Text,
  textLevel,
} from '../../../../../packages';
import { AppointmentsFilterDates, AppointmentsFilterStatus } from '../../../../../constants/CommonConstants';

import {
  getConversationAssignmentReport,
  getDctAssignmentReport,
  getEvaluationAssignmentReport,
} from '../../../../../services/conversation/conversation.service';

import { chartOptions } from './AssignmentsCard.utils';
import { useStyles } from './AssignmentsCard.styles';

const AssignmentsCard = ({ conversation, isEvaluation, version, evaluationId }) => {
  const classes = useStyles();
  const { templateId } = useParams();
  const [days, setDays] = useState(AppointmentsFilterDates[2].value);
  const [status] = useState(AppointmentsFilterStatus[0].value);
  const [chartDates, setChartDates] = useState([]);
  const [chartSeries, setChartSeries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [noData, setNoData] = useState(false);

  const fetchConversationAssignmentReports = () => {
    if (isEvaluation) {
      setIsLoading(true);
      getEvaluationAssignmentReport(evaluationId, days, version)
        .then(res => {
          const dates = [];
          const series = [];
          if (res.data?.length <= 0) {
            setNoData(true);
          } else {
            setNoData(false);
          }
          res.data.forEach(item => {
            dates.push(item.assignmentDate);
            series.push(item.assignmentCount);
          });

          setChartSeries(series);
          setChartDates(dates);
          setIsLoading(false);
        })
        .catch(err => {
          console.log('err ', err);
          setIsLoading(false);
        });
      return;
    }
    setIsLoading(true);

    getConversationAssignmentReport(days, { conversationId: conversation?.conversationId }, version)
      .then(res => {
        const dates = [];
        const series = [];
        if (res.data?.length <= 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
        res.data.forEach(item => {
          dates.push(item.assignmentDate);
          series.push(item.assignmentCount);
        });

        setChartSeries(series);
        setChartDates(dates);
        setIsLoading(false);
      })
      .catch(err => {
        console.log('err ', err);
        setIsLoading(false);
      });
  };

  const fetchDctAssignmentReports = () => {
    setIsLoading(true);
    getDctAssignmentReport(templateId, days)
      .then(res => {
        const dates = [];
        const series = [];
        if (res.data?.length <= 0) {
          setNoData(true);
        }
        res.data.forEach(item => {
          dates.push(item.assignmentDate);
          series.push(item.assignmentCount);
        });

        setChartSeries(series);
        setChartDates(dates);
        setIsLoading(false);
      })
      .catch(err => {
        console.log('err ', err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (conversation) {
      fetchConversationAssignmentReports();
    } else {
      fetchDctAssignmentReports();
    }
  }, [days, status]);

  return (
    <Box className={classes.card}>
      <Box className={classes.head}>
        <Heading className={classes.title}>Assignments chart</Heading>
        <Box className={classes.headRight}>
          <Select
            value={days}
            name="days"
            variant={selectType.PRIMARY}
            options={AppointmentsFilterDates}
            onChange={e => setDays(Number(e.target.value))}
          />
          {/* <Select
            value={status}
            name="status"
            variant={selectType.PRIMARY}
            options={AppointmentsFilterStatus}
            onChange={(e: ChangeEvent<HTMLSelectElement>) => setStatus(e.target.value)}
          /> */}
        </Box>
      </Box>
      <Box className={classes.chart}>
        {!isLoading ? (
          !noData ? (
            <ApexChart
              options={chartOptions(chartDates)}
              series={[{ data: chartSeries }]}
              type="line"
              height={330}
            />
          ) : (
            <Box display="flex" justifyContent="center">
              <Text weight={fontWeight.SEMI_BOLD} level={textLevel.S}>
                No Record Found
              </Text>
            </Box>
          )
        ) : (
          <div className={classes.loader}>
            <Icons className="rotate linear infinite" glyph="in-progress" color={colors.primary} />
          </div>
        )}
      </Box>
    </Box>
  );
};

export { AssignmentsCard };
